export enum DropType {
  All = 'all',
  Gif = 'gif',
  Image = 'image',
  Video = 'video',
}

export enum DropZoneType {
  Avatar = 'avatar',
  Compact = 'compact',
  Regular = 'regular',
}
